import React from "react";
import ReactDOM from "react-dom";
import Pagess from "./Pagess";

ReactDOM.render(<Pagess />, document.getElementById("root"));
//ReactDOM.render(<App />, document.getElementById("root"));
//ReactDOM.render(<Apptest />, document.getElementById("root"));
